<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.20889 10.2709V14.5707C7.20889 15.008 7.56399 15.363 8.00126 15.363C8.43852 15.363 8.79352 15.008 8.79352 14.5707V10.2709C8.79352 9.83366 8.43852 9.47857 8.00126 9.47857C7.56399 9.47857 7.20889 9.83366 7.20889 10.2709ZM5.73277 7.21008H1.43298C0.99572 7.21008 0.640625 7.56517 0.640625 8.00244C0.640625 8.4397 0.99572 8.7947 1.43298 8.7947H5.73277C6.17003 8.7947 6.52503 8.4397 6.52503 8.00244C6.52503 7.56517 6.17003 7.21008 5.73277 7.21008ZM14.5695 7.21008H10.2697C9.83248 7.21008 9.47739 7.56517 9.47739 8.00244C9.47739 8.4397 9.83248 8.7947 10.2697 8.7947H14.5695C15.0068 8.7947 15.3618 8.4397 15.3618 8.00244C15.3618 7.56517 15.0068 7.21008 14.5695 7.21008ZM7.20889 1.43418V5.73395C7.20889 6.17121 7.56399 6.52631 8.00126 6.52631C8.43852 6.52631 8.79352 6.17121 8.79352 5.73395V1.43418C8.79352 0.996881 8.43852 0.641846 8.00126 0.641846C7.56399 0.641846 7.20889 0.996881 7.20889 1.43418Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'Crosshair'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
